import React from "react";
import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";

function CloseButton() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    // Dispatch the actions first (regardless of the role)
    dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
    dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));

    // Then handle the navigation based on the role
    if (localStorage.getItem("roleName") === "DeptUser") {
      navigate("/UserDeptDashboard");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <Stack my={3} direction={"row"} justifyContent={"end"}>
      <Button variant="outlined" onClick={handleClick}>
        Back
      </Button>
    </Stack>
  );
}

export default CloseButton;
